module.exports = __webpack_public_path__ + "static/media/preview_stamp_campaign_details_page_task_startted_photos.eb5a65a6.svg";